import { useRef } from "react";
import { NavLink } from "react-router-dom";

import { CSSTransition } from "react-transition-group";
import { SiFacebook, SiInstagram, SiYoutube } from "react-icons/si";

import Particles from "../components/Particles";

const Menu = ({menuOn, setMenuOn, pageCurrent}) => {
  const partMenuRef = useRef(null);

  const onLinkClick = () => {
    setMenuOn(curMenuActive => !curMenuActive);    
  }

  return (
    <CSSTransition nodeRef={partMenuRef} in={menuOn} timeout={2000} classNames='menu' mountOnEnter unmountOnExit>
      <div className="part menu" ref={partMenuRef}>
  
        <section className="sector sector-h-full">
          <div className="container container-w-full container-w-no-gutter-out">
            <div className="container-in menu-toggle2 hover-glitchx hover-slidex hover-stagger hover-slantx" >
              <nav className="links">
                <NavLink className= {({isActive}) => "link" + (isActive ? " active" : "")} to="/" end onClick={onLinkClick}>
                  {/* {(pageCurrent === "home") && <Particles />} */}
                  <Particles />
                  <div className="link-in home">
                    <span>H</span><span>O</span><span>M</span><span>E</span>
                  </div>
                </NavLink>
                <NavLink className= {({isActive}) => "link" + (isActive ? " XXXactive" : "")} to="/coming" end onClick={onLinkClick}>
                  {/* {(pageCurrent === "web") && <Particles />} */}
                  <Particles />
                  <div className="link-in web">
                    <span>W</span><span>E</span><span>B</span><span>S</span><span>I</span><span>T</span><span>E</span><span>S</span>
                  </div>
                </NavLink>
                <NavLink className= {({isActive}) => "link" + (isActive ? " XXXactive" : "")} to="/coming" end onClick={onLinkClick}>
                  {/* {(pageCurrent === "email") && <Particles />} */}
                  <Particles />
                  <div className="link-in email">
                    <span>E</span><span>M</span><span>A</span><span>I</span><span>L</span><span>&nbsp;</span><span>C</span><span>A</span><span>M</span><span>P</span><span>A</span><span>I</span><span>G</span><span>N</span>
                  </div>
                </NavLink>
                <NavLink className= {({isActive}) => "link" + (isActive ? " XXXactive" : "")} to="/coming" end onClick={onLinkClick}>
                  {/* {(pageCurrent === "graphic") && <Particles />} */}
                  <Particles />
                  <div className="link-in graphic">
                    <span>G</span><span>R</span><span>A</span><span>P</span><span>H</span><span>I</span><span>C</span><span>&nbsp;</span><span>D</span><span>E</span><span>S</span><span>I</span><span>G</span><span>N</span>
                  </div>
                </NavLink>
                <NavLink className= {({isActive}) => "link" + (isActive ? " XXXactive" : "")} to="/coming" end onClick={onLinkClick}>
                  {/* {(pageCurrent === "photo") && <Particles />} */}
                  <Particles />
                  <div className="link-in photo">
                    <span>P</span><span>H</span><span>O</span><span>T</span><span>O</span><span>G</span><span>R</span><span>A</span><span>P</span><span>H</span><span>Y</span>
                    </div>
                </NavLink>
                <NavLink className= {({isActive}) => "link" + (isActive ? " XXXactive" : "")} to="/coming" end onClick={onLinkClick}>
                  {/* {(pageCurrent === "retouch") && <Particles />} */}
                  <Particles />
                  <div className="link-in retouch">
                    <span>P</span><span>H</span><span>O</span><span>T</span><span>O</span><span>&nbsp;</span><span>R</span><span>E</span><span>T</span><span>O</span><span>U</span><span>C</span><span>H</span><span>I</span><span>N</span><span>G</span>
                  </div>
                </NavLink>
                <NavLink className= {({isActive}) => "link" + (isActive ? " XXXactive" : "")} to="/contact" end onClick={onLinkClick}>
                  {/* {(pageCurrent === "contact") && <Particles />} */}
                  <Particles />
                  <div className="link-in contact">
                    <span>C</span><span>O</span><span>N</span><span>T</span><span>A</span><span>C</span><span>T</span>
                </div>
                </NavLink>
              </nav>
              <div className="connects">
                <div className="connect email"><div className="connect-in text"><span className="item">f9@factory9.net</span></div></div>
                <div className="connect facebook"><div className="connect-in icon"><span className="item"><SiFacebook /></span></div></div>
                <div className="connect instagram"><div className="connect-in icon"><span className="item"><SiInstagram /></span></div></div>
                <div className="connect youtube"><div className="connect-in icon"><span className="item"><SiYoutube/></span></div></div>
              </div> 
            </div>
          </div>
        </section>
  
      </div>
    </CSSTransition>
  )
}

export default Menu;

